import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "mt-10" }

import { ref } from "vue";
import { useSidebar } from "../hooks/useSidebar";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props) {

const { isOpen } = useSidebar();
const activeClass = ref(
  "bg-gray-600 bg-opacity-25 text-gray-100 border-gray-100"
);
const inactiveClass = ref(
  "border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100"
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'block' : 'hidden', "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden"]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([_unref(isOpen) ? 'translate-x-0 ease-out' : '-translate-x-full ease-in', "fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0"])
    }, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center justify-center mt-8" }, [
        _createElementVNode("div", { class: "flex items-center" }, [
          _createElementVNode("span", { class: "mx-2 text-2xl font-semibold text-white" }, "Hela CMS")
        ])
      ], -1)),
      _createElementVNode("nav", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "pl-4 text-xs font-semibold mb-4 text-gray-400" }, "GENERAL", -1)),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Dashboard' ? activeClass.value : inactiveClass.value]]),
          to: "/dashboard"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              })
            ], -1),
            _createElementVNode("span", { class: "mx-4" }, "Dashboard", -1)
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'Blogs' ? activeClass.value : inactiveClass.value]]),
          to: "/blogs"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M5 3C3.89543 3 3 3.89543 3 5V7C3 8.10457 3.89543 9 5 9H7C8.10457 9 9 8.10457 9 7V5C9 3.89543 8.10457 3 7 3H5Z",
                fill: "currentColor"
              }),
              _createElementVNode("path", {
                d: "M5 11C3.89543 11 3 11.8954 3 13V15C3 16.1046 3.89543 17 5 17H7C8.10457 17 9 16.1046 9 15V13C9 11.8954 8.10457 11 7 11H5Z",
                fill: "currentColor"
              }),
              _createElementVNode("path", {
                d: "M11 5C11 3.89543 11.8954 3 13 3H15C16.1046 3 17 3.89543 17 5V7C17 8.10457 16.1046 9 15 9H13C11.8954 9 11 8.10457 11 7V5Z",
                fill: "currentColor"
              }),
              _createElementVNode("path", {
                d: "M11 13C11 11.8954 11.8954 11 13 11H15C16.1046 11 17 11.8954 17 13V15C17 16.1046 16.1046 17 15 17H13C11.8954 17 11 16.1046 11 15V13Z",
                fill: "currentColor"
              })
            ], -1),
            _createElementVNode("span", { class: "mx-4" }, "Blogs", -1)
          ])),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["flex items-center px-6 py-2 mt-4 duration-200 border-l-4", [_ctx.$route.name === 'tourGuides' ? activeClass.value : inactiveClass.value]]),
          to: "/tour-guides"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "w-5 h-5",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M5 3C3.89543 3 3 3.89543 3 5V7C3 8.10457 3.89543 9 5 9H7C8.10457 9 9 8.10457 9 7V5C9 3.89543 8.10457 3 7 3H5Z",
                fill: "currentColor"
              }),
              _createElementVNode("path", {
                d: "M5 11C3.89543 11 3 11.8954 3 13V15C3 16.1046 3.89543 17 5 17H7C8.10457 17 9 16.1046 9 15V13C9 11.8954 8.10457 11 7 11H5Z",
                fill: "currentColor"
              }),
              _createElementVNode("path", {
                d: "M11 5C11 3.89543 11.8954 3 13 3H15C16.1046 3 17 3.89543 17 5V7C17 8.10457 16.1046 9 15 9H13C11.8954 9 11 8.10457 11 7V5Z",
                fill: "currentColor"
              }),
              _createElementVNode("path", {
                d: "M11 13C11 11.8954 11.8954 11 13 11H15C16.1046 11 17 11.8954 17 13V15C17 16.1046 16.1046 17 15 17H13C11.8954 17 11 16.1046 11 15V13Z",
                fill: "currentColor"
              })
            ], -1),
            _createElementVNode("span", { class: "mx-4" }, "Travel Guides", -1)
          ])),
          _: 1
        }, 8, ["class"]),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "pl-4 my-2 text-xs font-semibold mb-4 text-gray-400 hidden" }, " Examples ", -1))
      ])
    ], 2)
  ]))
}
}

})